import type { OrganizerProfileVisibilityResponse } from '@/types/organizerProfileVisibility';

export const fetchOrganizerProfileVisibility = async (
  organizerId: string,
): Promise<OrganizerProfileVisibilityResponse> => {
  const url = `/e/api/organizer/${encodeURIComponent(organizerId)}/profile`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Organizer profile request failed: ${response.status}`);
  }

  const payload = (await response.json()) as OrganizerProfileVisibilityResponse;
  return {
    hideAttendeeCount: payload?.hideAttendeeCount === true,
    hideTotalEvents: payload?.hideTotalEvents === true,
  };
};
